import React, { useRef } from "react";
import { toast } from "sonner";
import { openFeeWhatsApp, phoneToWaMe } from "../lib/schoolFeeMessages";
import { FieldHint } from "./createEvent/CreateEventFormUi";
import { ReadableNavButton } from "./Sticker";
import {
  WorkflowModalBody,
  WorkflowModalFooter,
  WorkflowModalHeader,
  WorkflowModalShell,
} from "./workflow/WorkflowModal";

export default function WhatsAppFollowUpPrompt({
  title,
  description,
  phone,
  message,
  onClose,
  testId = "whatsapp-follow-up",
}) {
  const dialogRef = useRef(null);
  const hasPhone = Boolean(phoneToWaMe(phone));

  function send() {
    const opened = openFeeWhatsApp({ phone, message });
    if (!opened) {
      toast.error("No phone on file for WhatsApp");
      return;
    }
    onClose();
  }

  function copy() {
    navigator.clipboard.writeText(message).then(
      () => toast.success("Message copied"),
      () => toast.error("Could not copy"),
    );
  }

  return (
    <WorkflowModalShell
      dialogRef={dialogRef}
      onClose={onClose}
      onBackdropClose={onClose}
      testId={`${testId}-modal`}
      titleId={`${testId}-title`}
      layout="sheet"
    >
      <WorkflowModalHeader
        title={title}
        titleId={`${testId}-title`}
        onClose={onClose}
        sticky
      />
      <WorkflowModalBody sheet className="space-y-3">
        <FieldHint>{description}</FieldHint>
        <p className="rounded-md2 border border-black/[0.08] bg-black/[0.03] px-3 py-3 text-sm whitespace-pre-wrap">
          {message}
        </p>
        {!hasPhone ? (
          <FieldHint>No phone is on file. You can still copy the message.</FieldHint>
        ) : null}
      </WorkflowModalBody>
      <WorkflowModalFooter sticky safeArea className="flex flex-wrap gap-2">
        <ReadableNavButton
          type="button"
          variant="primary"
          disabled={!hasPhone}
          onClick={send}
          data-testid={`${testId}-send`}
        >
          Send on WhatsApp
        </ReadableNavButton>
        <ReadableNavButton
          type="button"
          onClick={copy}
          data-testid={`${testId}-copy`}
        >
          Copy message
        </ReadableNavButton>
        <ReadableNavButton type="button" onClick={onClose}>
          Skip
        </ReadableNavButton>
      </WorkflowModalFooter>
    </WorkflowModalShell>
  );
}
